import { render } from "./TableSortTH.vue?vue&type=template&id=d947d1be&scoped=true"
import script from "./TableSortTH.vue?vue&type=script&lang=js"
export * from "./TableSortTH.vue?vue&type=script&lang=js"

import "./TableSortTH.vue?vue&type=style&index=0&id=d947d1be&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d947d1be"]])

export default __exports__